import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildRefetchSkillsOnDeleteSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const DELETE_SKILL_TOOL_NAMES = ['delete_skill'];

const buildRefetchSkillsOnDeleteSubscription = (
    _params: BuildRefetchSkillsOnDeleteSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'refetch-skills-on-delete',
        routePattern: '*',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event }) => {
            if (!eventMatchesToolNames({ event, toolNames: DELETE_SKILL_TOOL_NAMES })) {
                return false;
            }

            const result = coerceToRecord({ value: event.result });
            return result.success === true;
        },
        action: ({ event, queryClient }) => {
            const args = coerceToRecord({ value: event.args });
            const deletedSkillId = getStringValue({ value: args.skillId });
            queryClient.invalidateQueries(['skills']);
            queryClient.invalidateQueries(['skills-search']);
            if (deletedSkillId) {
                queryClient.invalidateQueries(['skill', deletedSkillId]);
            }
        },
    };
};

export default buildRefetchSkillsOnDeleteSubscription;
